import { createSelector } from '@reduxjs/toolkit';
import { ACCOUNT_FEATURE, USER_ROLE } from '~/constants';
import identity from '~/identity';
import { selectFeature } from '~/selectors';

let selector;

export default createSelector(identity, (state) => {
  selector ??= selectFeature(ACCOUNT_FEATURE.USER_ROLES);
  const [, { enabled, ...roles }] = selector(state);
  return enabled
    ? Object.values(USER_ROLE).filter((role) => roles[role])
    : [USER_ROLE.GUEST, USER_ROLE.BROADCASTER, USER_ROLE.ADMIN];
});
